/**
 * `/admin/commercial` — Pilotage de l'offre commerciale.
 *
 * Regroupe :
 *  - Compteurs live (bêta / lancement / standard)
 *  - Paramètres tarifaires et ouverture / fermeture bêta
 *  - Enrôlement des bêta-testeurs (coupon 50 % à vie appliqué automatiquement)
 */
import React from "react";
import { AdminPageHeader } from "./ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Sparkles, Rocket } from "lucide-react";
import { OffersTab, BetaTab } from "@/pages/app/PlatformAdminPage";

export default function AdminCommercialPage() {
  return (
    <div className="animate-fade-up text-foreground">
      <AdminPageHeader
        overline="Commercial"
        title="Pilotage de l'offre Fonbex"
        description="Ajustez les prix, ouvrez/fermez la bêta et gérez les 250 places de lancement. Les changements se propagent en temps réel sur la landing page."
        testId="admin-commercial-header"
      />
      <div className="rounded-2xl bg-background text-foreground p-4 sm:p-6 border border-white/10">
        <Tabs defaultValue="offers">
          <TabsList className="mb-6">
            <TabsTrigger value="offers" data-testid="admin-commercial-tab-offers">
              <Rocket className="h-3.5 w-3.5 mr-1.5" />Prix &amp; compteurs
            </TabsTrigger>
            <TabsTrigger value="beta" data-testid="admin-commercial-tab-beta">
              <Sparkles className="h-3.5 w-3.5 mr-1.5" />Programme Bêta
            </TabsTrigger>
          </TabsList>
          <TabsContent value="offers"><OffersTab /></TabsContent>
          <TabsContent value="beta"><BetaTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
